export default {
  // 模式
  "common.mode.auto": "Режим самостоятельного использования собственной выработанной энергии",
  "common.mode.economy": "Экономический режим",
  "common.mode.exigency": "Режим чрезвычайной ситуации",

  // 设备
  "common.grid": "Электрическая сеть",
  "common.evChargers": "Зарядное устройство",
  "common.evCharger": "Зарядное устройство",
  "common.pv": "Фотовольтаика (ФВ)",
  "common.inverter": "Инвертор",
  "common.pcs": "Инвертор + батарея",
  "common.terminal": "Терминальное устройство",
  "common.airc": "Кондиционер",
  "common.engine": "Двигатель",
  "common.battery": "Батарея",
  "common.metter": "Электрический счётчик",
  "common.other": "Другое",
  "common.power": "Мощность",
  "common.powerTotal": "Общая мощность",
  "common.voltage": "Напряжение",
  "common.electricity": "Электрическая энергия",
  "common.current": "Ток",
  "common.homeUsage": "Общая нагрузка дома",
  "common.battery.power": "Мощность батареи",

  // 数据
  "common.noDataAvailable": "Данные в настоящее время недоступны~",
  "common.tips": "Совет",
  "common.reset": "Сбросить",
  "common.currencyUnit": "¥",
  "common.submiting": "Отправка... Пожалуйста, подождите...",
  "common.close": "Закрыть",
  "common.from": "Из",
  "common.useIn": "Для",
  "common.energyPercent": "Процент потока энергии",
  "common.dataFlow": "Поток данных",
  "common.getDataIng": "Получение данных... Пожалуйста, подождите...",
  "common.pageLoading": "Загрузка содержимого страницы... Пожалуйста, подождите...",
  "common.reseting": "Сброс содержимого страницы... Пожалуйста, подождите...",
  "common.save": "Сохранить",
  "common.onlyNumberTips": "Можно вводить только цифры",
  "common.offline": "Оффлайн",
  "common.online": "Онлайн",
  "common.fault": "Ошибка",
  "common.charge": "Зарядка",
  "common.discharge": "Разрядка",
  "common.buy": "Купить",
  "common.sell": "Продать",
  "common.loadingInfo": "Загрузка... Пожалуйста, подождите...",

  // 
  "common.moreFeatures": "Дополнительные функции",
  "common.confirm": "Подтвердить",
  "common.saveing": "Сохранение... Пожалуйста, подождите...",
  "common.searchPlacholder": "Введите ключевое слово для поиска",
  "common.iSee": "Понимаю",
  "common.pageErrorTips1": "Ой, произошла ошибка на странице~",
  "common.pageErrorTips2": "Попробуйте обновить страницу или свяжитесь с поддержкой~",
  "common.refresh": "Обновить",
  "common.backToHome": "Вернуться на главную страницу",
  "common.checkTips": "Проверка... Пожалуйста, подождите...",
  "common.back": "Назад",
  "common.cancel": "Отменить",
  "common.optional": "Дополнительно",
  "common.required": "Обязательно",
  "common.status": "Статус",
  "common.statusNoDelete": "Не удален",
  "common.statusDelete": "Удален",
  "common.submit": "Отправить",
  "common.disable": "Отключить",
  "common.enable": "Включить",
  "common.year": "год",
  "common.month": "месяц",
  "common.day": "день",
  "common.version": "Версия:",
  "common.backHome": " Вернуться на главную страницу",
  "common.backHomeSorry": " К сожалению, страница случайно потеряла путь",
  "common.requestTips1": "Обработка данных в процессе, не отправляйте повторно",
  "common.requestTips2": "Системные уведомления",
  "common.requestTips3": "Срок действия сессии истек, пожалуйста, войдите снова",
  "common.requestTips4": "Войти снова",
  "common.requestTips5": "Неверная сессия или срок её действия истек, пожалуйста, войдите снова.",
  "common.requestTips6": "Ошибка сервера, пожалуйста, попробуйте позже.",
  "common.requestTips7": "Срок действия запроса к системному интерфейсу истек",
  "common.requestTips8": "Системный интерфейс",
  "common.requestTips9": "Ошибка",
  "common.iknow": "Понимаю",
  "common.logoutSuccess": "Успешный выход",
  
  // 了解更多组件
  "common.knowMore.title": "Для получения дополнительной информации свяжитесь с Beineng",
  "common.knowMore.email": "Электронная почта для связи",
  "common.knowMore.phone": "Телефон для связи",
  "common.knowMore.wechat": "WeChat для связи",
  "common.knowMore.website": "Адрес официального сайта",
  "common.knowMore.address": "Адрес для связи",
  "common.knowMore.addressDetail": "Комнаты 1205, 1301, здание 5, ул. Цинхэ, 8, село Хуанцзинькен, Хуанцзян, город Донгуань, провинция Гуандун",
  
  // 本地连接组件
  "common.localConnection": "Локальное подключение",
  "common.operateInApp": "Выполните действие в приложении!",
  
  "common.enbleStaus": "Статус включения",
  "common.battery.status": "Без заряда и разряда",

  "account.forgetThePassword": "Забыли пароль",
  "account.logInDirectly": "Войти напрямую",
  "account.tips1": "Перенаправление на страницу... Пожалуйста, подождите...",
  "account.tips2": "Сначала прочитайте и примите условия использования!",
  "account.autoLogin": "Автоматический вход",
  "account.userLogin": "Вход пользователя",
  "account.registerTips": "Ещё нет аккаунта? Нажмите здесь для регистрации",
  "account.userEmail": "Имя пользователя / электронная почта",
  "account.userEmailTips": "Введите имя пользователя или электронную почту",
  "account.password": "Пароль",
  "account.passwordTips": "Введите пароль",
  "account.submit": "Отправить",
  "account.submitTips": "Отправка... Пожалуйста, подождите...",
  "account.otherLoginTips": "Или выберите другой способ входа",
  "account.userRegistration": "Регистрация пользователя",
  "account.userName": "Имя пользователя",
  "account.userNameTips": "Введите имя пользователя",
  "account.emailTips1": "Введите адрес электронной почты",
  "account.emailTips2": "Неверный формат электронной почты",
  "account.phone": "Номер телефона",
  "account.phoneTips1": "Введите номер телефона",
  "account.phoneTips2": "Неверный номер телефона",
  "account.phoneTips3": "Введите номер телефона",
  "account.passwordTips1": "Введите пароль (6-30 символов)",
  "account.passwordTips2": "Неверный формат пароля: пароль должен содержать латинские буквы, цифры, подчеркивания, дефисы и точки, длина 6-12 символов",
  "account.passwordTips3": "Два введенных пароля не совпадают, пожалуйста, проверьте и введите снова!",
  "account.passwordTips4": "Введите пароль: пароль должен содержать латинские буквы, цифры, подчеркивания, дефисы и точки",
  "account.passwordTips5": "Подтверждение пароля",
  "account.passwordTips6": "Введите подтверждение пароля",
  "account.passwordTips7": "Два введенных пароля не совпадают, пожалуйста, проверьте и введите снова!",
  "account.passwordTips8": "Введите подтверждение пароля",
  "account.passwordTips9": "Поздравляем, регистрация успешна!",
  "account.passwordTips10": "Ваше имя пользователя:",
  "account.emailIs": "Электронная почта:",
  "account.goToLoginPage": "Через s секунд вы будете автоматически перенаправлены на страницу входа",
  "account.goLogin": "Войти",
  "account.goRegister": "Зарегистрироваться",
  "account.loginSuccess": "Успешный вход",
  "account.email": "Электронная почта",
  "account.sologn": "Мы тщательно создаем индивидуальный энергетический план для вас",
  "account.pleaseAgree": "Я прочитал(а) и принимаю",
  "userAgreement.privacyPolicy": "политику конфиденциальности",

  "account.code": "Код подтверждения",
  "account.codeTips": "Введите код подтверждения",
  "account.codeTips2": "Неверный код подтверждения",

    "account.inviteCodeTips": "Введите код приглашения",
    "account.inviteCodeHint": "Для получения кода приглашения обратитесь к установщику или персоналу по эксплуатации и обслуживанию",
  "account.modifyPasswordByAccount": "Изменить пароль через аккаунт",
  "account.modifyPasswordByEmail": "Изменить пароль через электронную почту",
  "account.getPasswordByAccount": "Восстановить пароль через аккаунт",
  "account.getPasswordByEmail": "Восстановить пароль через электронную почту",

  "account.sendEmailTips": "Код подтверждения отправлен на электронную почту, пожалуйста, проверьте",
  "account.name": "Имя аккаунта",
  "account.newPassword": "Новый пароль",
  "account.confirmNewPassword": "Подтверждение нового пароля",
  "account.nameTips": "Введите имя аккаунта",
  "account.passwordModifySuccess": "Пароль успешно изменен",
  "account.emailCode": "Код подтверждения электронной почты",
  "account.emailCodeTips": "Введите код подтверждения электронной почты",
  "account.emailCodeTips2": "Неверный код подтверждения электронной почты",
  "account.emailModifySuccess": "Пароль успешно изменен",
  "account.passworTips1": "Ваш пароль успешно сброшен!",
  "account.passwordTips11": "Введите подтверждение пароля",
  "account.passwordTips12": "Введите новый пароль",
  "account.nickname": "Псевдоним пользователя",
  "account.modifyNickname": "Изменить псевдоним пользователя",
  "account.modifyNicknameSuccess": "Псевдоним пользователя успешно изменен!",
  "account.nicknameTips": "Введите псевдоним пользователя",
  "account.nicknameError": "Не удалось изменить псевдоним пользователя!",

  "account.login": "Войти",
  "account.quickRegister": "Быстрая регистрация",
  "account.sendCode": "Получить код",
  "account.sendTips": "Можно отправить снова через s секунд",
  "account.sendEmailIng": "Отправка электронной почты... Пожалуйста, подождите...",
  "account.emailNotEmpty": "Адрес электронной почты не может быть пустым",
  "account.registerAccount": "Регистрация аккаунта",
  "account.registerWelcome": "Добро пожаловать в регистрацию SusprSafe",
  "account.usernameLimit": "Имя пользователя должно начинаться с буквы и может содержать только буквы, цифры и подчеркивания, длина 5-15 символов",

  "copyright.desc2": "Информация о регистрации сайта: Регистрация ICP Гуандун № 2021169764",

  "editUserInfo.editUserInformation": "Редактирование информации о пользователе",
  "editUserInfo.modifyUsername": "Изменить имя пользователя",
  "editUserInfo.changePictures": "Изменить аватар",
  "editUserInfo.savePicturesSuccess": "Аватар пользователя успешно сохранен",
  "editUserInfo.saveError": "Сохранение не удалось",
  "editUserInfo.pictureLimit": "Размер изображения должен быть меньше 2 МБ",
  "editUserInfo.uploadPicture": "Загрузить аватар",
  "editUserInfo.picturePreview": "Предпросмотр",
  
  "editUserInfo.bindPhoneNumber": "Привязать номер телефона",
  "editUserInfo.bindEmail": "Привязать электронную почту",
  "editUserInfo.changePassword": "Изменить пароль",

  "editUserInfo.notificationSettings": "Настройки уведомлений",
  "editUserInfo.editAccount": "Редактирование информации об аккаунте пользователя",
  "editUserInfo.waitBingting": "Привязка... Пожалуйста, подождите...",
  "editUserInfo.collapse": "Свернуть",
  "editUserInfo.modifyBinding": "Изменить привязку",
  
  "editUserInfo.emailAddress": "Адрес электронной почты",
  "editUserInfo.tips1": "Электронная почта успешно привязана",
  "editUserInfo.tips2": "Сохранение не удалось",
  "editUserInfo.tips3": "Отправка кода подтверждения электронной почты... Пожалуйста, подождите...",
  "editUserInfo.tips4": "Код подтверждения отправлен на электронную почту xxxx, пожалуйста, проверьте",
  "editUserInfo.tips5": "Не удалось Получить код!",
  "editUserInfo.tips6": "Номер телефона уже привязан",
  "editUserInfo.tips7": "Электронная почта уже привязана",
  "editUserInfo.emailTips1": "Введите адрес электронной почты",
  "editUserInfo.emailTips2": "Неверный формат электронной почты",
  "editUserInfo.emailTips3": "Можно отправить снова через xxxx секунд",
  "editUserInfo.emailTips4": "Получить код",
  "editUserInfo.emailTips5": "Код подтверждения электронной почты не может быть пустым",
  "editUserInfo.emailTips6": "Неверный код подтверждения электронной почты",
  "editUserInfo.emailCode": "Код подтверждения электронной почты",
  "editUserInfo.save": "Сохранить",

  "editUserInfo.phoneTips1": "Номер телефона успешно привязан",
  "editUserInfo.phoneTips2": "Отправка SMS-кода подтверждения... Пожалуйста, подождите...",
  "editUserInfo.phoneTips3": "SMS-код подтверждения отправлен на номер телефона xxxx, пожалуйста, проверьте",
  "editUserInfo.phoneTips4": "Не удалось отправить SMS-код подтверждения!",
  "editUserInfo.phoneTips5": "Введите номер телефона",
  "editUserInfo.phoneTips6": "Неверный формат номера телефона",
  "editUserInfo.phoneTips7": "Отправить SMS-код подтверждения",
  "editUserInfo.phoneTips8": "SMS-код подтверждения",
  "editUserInfo.phoneTips9": "SMS-код подтверждения не может быть пустым",
  "editUserInfo.phoneTips10": "Неверный SMS-код подтверждения",
  "editUserInfo.phone": "Номер телефона",


  "editUserInfo.noticeTips1": "Не удалось получить настройки уведомлений!",
  "editUserInfo.noticeTips2": "Настройки уведомлений успешно сохранены!",
  "editUserInfo.noticeTips3": "Уведомление о низком уровне батареи",
  "editUserInfo.noticeTips4": "Уведомление о завершении заряда зарядного устройства",
  "editUserInfo.errorNotification": "Уведомление об ошибке",
  "editUserInfo.updateNotification": "Уведомление об обновлении",
  "editUserInfo.monthlyStatisticsNotification": "Уведомление о ежемесячной статистике",
  "editUserInfo.notificationMethod": "Способ получения",

  "editUserInfo.userNameTips1": "Имя пользователя успешно сохранено",
  "editUserInfo.userNameTips2": "Не удалось сохранить имя пользователя",
  "editUserInfo.userNameTips3": "Введите имя пользователя",
  "editUserInfo.userNameTips4": "Неверный формат имени пользователя: может содержать только цифры, подчеркивания и латинские буквы",
  "editUserInfo.userNameTips5": "Введите имя пользователя",
  "editUserInfo.userNameTips6": "Сохранение... Пожалуйста, подождите...",
  "editUserInfo.userName": "Имя пользователя",

  "editUserInfo.avatorTips": "Нажмите, чтобы изменить аватар",
  "editUserInfo.verifyCodeTips1": "Введите полученный код подтверждения:",
  "editUserInfo.verifyCodeTips2": "Для безопасности вашего аккаунта нажмите кнопку ниже, чтобы Получить код на исходный номер телефона:",
  "editUserInfo.verifyCodeTips3": "Получить код",
  "editUserInfo.verifyCodeTips4": "Проверка исходного номера телефона успешна, введите новый привязанный номер телефона",
  "editUserInfo.verifyCodeTips5": "Для безопасности вашего аккаунта нажмите кнопку ниже, чтобы Получить код на исходную электронную почту:",
  "editUserInfo.verifyCodeTips6": "Проверка исходной электронной почты успешна, введите новую электронную почту",
  "editUserInfo.verifyCodeTips7": "Старый пароль",
  "editUserInfo.verifyCodeTips8": "Сначала привяжите электронную почту!",
  "editUserInfo.verifyCodeTips9": "Код подтверждения отправлен на электронную почту, пожалуйста, проверьте",
  "editUserInfo.verifyCodeTips10": ", вы будете автоматически перенаправлены на страницу входа",

  "hems.notice.title": "Заголовок уведомления", 
  "hems.notice.content": "Содержимое уведомления", 
  "hems.notice.operate": "Действие",
  "hems.notice.noRead": "Непрочитано",
  "hems.notice.read": "Прочитано",
  "hems.notice.warning": "Предупреждение",
  "hems.notice.error": "Ошибка",
  "hems.notice.success": "Расчет статистики",
  "hems.notice.sys": "Системная информация",
  "hems.notice.operateSuccess": "Действие успешно выполнено",
  "hems.notice.operateTips": "Выберите элемент для действия",

  // 首页
  "hems.home.selfuseRate": "Процент самостоятельного использования",
  "hems.home.percent": "Процент",
  "hems.home.todayData": "Данные за сегодня",
  "hems.home.todayPowerGeneration": "Выработка энергии за сегодня",
  "hems.home.salesIncome": "Доход от продажи энергии",
  "hems.home.saved": "Вы экономили",
  "hems.home.reduce": "Сократить углеродный след",
  "hems.home.tips1": "Данные в настоящее время недоступны, вы еще не привязали xxxx",
  "hems.home.criticalLoad": "Критическая нагрузка",
  "hems.home.keyVoltage": "Критическое напряжение",
  "hems.home.householdLoad": "Нагрузка дома",
  "hems.home.householdVoltage": "Напряжение в доме",
  "hems.home.generalLoad": "Обычная нагрузка",
  "hems.home.generalVoltage": "Обычное напряжение",
  "hems.home.batteryHealth": "Состояние здоровья батареи",
  "hems.home.averageTemp": "Средняя температура",
  "hems.home.gridLoad": "Нагрузка электросети",
  "hems.home.toggeleDataSource": "Отображаемые данные изменены на:",
  "hems.home.toggleTips": "Вы уверены, что хотите изменить?",
  "hems.home.modeSending": "Отправка команды режима... Пожалуйста, подождите...",
  "hems.home.modeSuccess": "Команда изменения режима успешно отправлена!",
  "hems.home.isOnline": "Онлайн?",
  "hems.home.useStatus": "Статус использования",
  "hems.home.workModeText": "Текущий режим работы:",
  "hems.home.toggleDataSourceText": "Отображаемые данные изменены на:",
  "hems.ev.charge.status": "Статус заряда",
  "hems.ev.charge.time": "Время заряда",
  "hems.ev.charge.count": "Фактический объем заряда",
  "hems.ev.charge.status.empty": "Пустой",
  "hems.ev.charge.status.ing": "Зарядка с подключенным кабелем",
  "hems.ev.charge.status.null": "Кабель подключен, но заряда нет",
  "hems.ev.charge.status.error": "Ошибка",
  "hems.hour": "час",
  "hems.minue": "минута",
  "hems.ev.chagre.number": "Номер зарядного устройства",

  // User Guide
  "hems.userGuide.selfUse": "Самостоятельное использование собственной выработанной энергии",
  "hems.userGuide.selfUseTips": "Сначала используйте фотовольтажную энергию, если она недостаточна, дополните из электросети",
  "hems.userGuide.economyMode": "Экономический режим",
  "hems.userGuide.economyModeTips": "Оптимизировать стратегию использования энергии в зависимости от цены электроэнергии",
  "hems.userGuide.emergencyMode": "Режим чрезвычайной ситуации",
  "hems.userGuide.emergencyModeTips": "Сначала обеспечить энергоснабжение критической нагрузки",

  // 图表页面
  "hems.history.energyStatistics": "Статистика энергии",
  "hems.history.revenueStatistics": "Статистика доходов",
  "hems.history.greenStatistics": "Снижение зеленых выбросов",
  "hems.history.revenueTitle": "Общий доход от продажи энергии",
  "hems.history.savingsTitle": "Общая экономия",
  "hems.history.carbonTitle": "Общее снижение углерода",
  "hems.history.day": "день",
  "hems.history.month": "месяц",
  "hems.history.year": "год",
  "hems.history.beforeDay": "вчера",
  "hems.history.afterDay": "завтра",
  "hems.history.beforeMonth": "пред. мес.",
  "hems.history.afterMonth": "след. мес.",
  "hems.history.beforeYear": "прошл. г.",
  "hems.history.afterYear": "след. г.",
  "hems.history.totalUse": "Общее использование",
  "hems.history.fullScreen": "Полный экран",
  "hems.history.timeSelect": "Выбрать дату",
  "sync.tips1": "Команда синхронизации данных успешно отправлена!",
  "sync.tips2": "Синхронизация данных в процессе, из-за большого объема данных требуется время, проверьте снова через полчаса~",
  "sync.tips3": "При синхронизации данных устройства может быть задержка, если вы заметите несоответствие в данных, нажмите:",
  "sync.tips4": "Синхронизировать данные",

  "charge.info": "Информация о зарядном устройстве",
  "news.loading": "Загрузка...",
  "news.noMore": "Данные закончились",
  "hems.pv.power": "Фотоэлектрическая мощность",

  // UEH specific
  "ueh.sellPower": "Объем проданной энергии",
  
  "menu.home": "Главная страница",
  "menu.history": "Исторические данные",
  "menu.device": "Устройства",
  "menu.settings": "Настройки",
  "menu.messageCenter": "Центр сообщений",
  "menu.help": "Помощь и поддержка",
  "menu.mine": "Мои данные",


  "mine.userSetting": "Настройки пользователя",
  "mine.terminalSetting": "Базовые настройки терминала",
  "mine.uploadCloud": "Загрузить данные в облако",
  "mine.changeVersion": "Проверить обновление",
  "mine.language": "Изменить язык",
  "mine.about": "О приложении",
  "mine.feedback": "Обратная связь",
  "mine.logout": "Выйти",
  "mine.logoutAccount": "Удалить аккаунт",

  "mine.logoutAccountTips": "Удаление аккаунта с именем []",
  "mine.logoutAccountTips1": "Удаление аккаунта, привязанного к []",
  "mine.logoutAccountCare": "Примечания к запросу на удаление аккаунта:",
  "mine.logoutAccountCare1": "1. Аккаунт находится в безопасном состоянии",
  "mine.logoutAccountCare1-1": "Аккаунт используется в обычном режиме, нет риска кражи, нарушения правил или блокировки.",
  "mine.logoutAccountCare2": "2. Авторизации и привязки аккаунта удалены",
  "mine.logoutAccountCare2-1": "Все авторизации аккаунта с другими сторонними платформами удалены.",
  "mine.logoutAccountCare3": "3. После удаления аккаунта восстановить его невозможно, данные пользователя будут удалены",
  "mine.logoutAccountCare3-1": "После удаления аккаунта привязанные номера телефонов, электронные почты и другие данные будут удалены и восстановить их невозможно.",
  "mine.confirmLogout": "Подтвердить удаление",
  "mine.logoutSuccess": "Аккаунт успешно удален!",


  "mine.feedbackIssues": "Обратная связь по проблемам",
  "mine.feedQuantity": "Количество",
  "mine.feedAmount": "Максимум 9 изображений, максимальный размер 1 МБ на изображение",

  "mine.notice.fail": "Не удалось получить настройки уведомлений!",
  "mine.notice.saveSuccess": "Настройки уведомлений успешно сохранены!",
  "mine.notice.saveFail": "Сохранение не удалось!",
  "mine.notice.title": "Настройки уведомлений",
  "mine.notice.batteryLow": "Уведомление о низком уровне батареи",
  "mine.notice.chargingFinish": "Уведомление о завершении заряда зарядного устройства",
  "mine.notice.error": "Уведомление об ошибке",
  "mine.notice.update": "Уведомление об обновлении",
  "mine.notice.monthly": "Уведомление о ежемесячной статистике",
  "mine.notice.receiveType": "Способ получения",

  "mine.language.welcome": "Добро пожаловать в SusprSafe",
  "mine.language.desc1": "Выберите версию языка в зависимости от места проживания",
  "mine.language.desc2": "Вы можете изменить его в любое время в настройках приложения",

  "mine.userInfo.avatar": "Аватар",
  "mine.userInfo.nickname": "Псевдоним",
  "mine.userInfo.password": "Пароль",
  "mine.userInfo.changePassword": "Изменить пароль",
  "mine.userInfo.setPassword": "Установить пароль",
  "mine.userInfo.phoneNumber": "Номер телефона",
  "mine.userInfo.bindPhone": "Привязать номер телефона",
  "mine.userInfo.bindEmail": "Привязать электронную почту",
  "mine.loginExpired": "Срок действия сессии истек, пожалуйста, войдите снова",
  "mine.userInfo.title": "Информация о пользователе",
  "mine.userInfo.bind": "Привязать",
  "mine.userInfo.modify": "Редактировать",
  "mine.userInfo.modifyNickname": "Изменить псевдоним",
  "mine.userInfo.userNickname": "Псевдоним пользователя",
  "mine.userInfo.selectPic": "Выберите изображение для загрузки",
  "mine.userInfo.saveSuccess": "Сохранение успешно",
  "mine.userInfo.uploadFail": "Загрузка не удалась",
  "mine.userInfo.avatarSaveSuccess": "Аватар успешно сохранен",
  "mine.userInfo.nameTips1": "Псевдоним пользователя не может быть пустым",
  "mine.userInfo.nameTips2": "Введите псевдоним пользователя",

  "common.pleaseSelect": "Пожалуйста, выберите",
  "question.commonQuestions": "Часто задаваемые вопросы",
  "account.toggleLanguage": "Изменить язык",
  "account.localConnection": "Локальное подключение",
  "account.selectLanguage": "Пожалуйста, выберите язык",
  "account.sendEmailToast": "Код подтверждения отправлен на электронную почту xxx, пожалуйста, проверьте",
  "account.emailError": "Неверный формат электронной почты",
  "account.sendEmailFail": "Отправка не удалась, пожалуйста, попробуйте снова",
  
  "common.submitting": "Отправка... Пожалуйста, подождите...",

  "device.page.noData": "Данные в настоящее время недоступны, эта страница может быть просмотрена только в приложении",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Обновление",
  "bmsFirmware.upgrading": "Обновление...",
  "bmsFirmware.uploadingFile": "Загрузка файла прошивки...",
  "bmsFirmware.upgradingProgress": "Обновление прошивки... {progress}%",
  "bmsFirmware.upgradeSuccess": "Обновление успешно",
  "bmsFirmware.upgradeSuccessSubtitle": "Обновление прошивки BMS завершено!",
  "bmsFirmware.upgradeFailed": "Обновление не удалось",
  "bmsFirmware.upgradeFailedFormError": "Пожалуйста, проверьте правильность заполнения формы",
  "bmsFirmware.upgradeFailedNetworkError": "Ошибка сети, повторите попытку",
  "bmsFirmware.invalidFileType": "Пожалуйста, выберите допустимый файл прошивки (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Пожалуйста, сначала выберите файл прошивки",
  "bmsFirmware.statusUpgrading": "Обновление",
  "bmsFirmware.statusCompleted": "Обновление завершено",
  "bmsFirmware.statusFailed": "Обновление не удалось",
  "bmsFirmware.deviceUpgrading": "Обновление пакета прошивки, обновление занимает 30-50 минут, во время обновления нельзя просматривать данные устройства в реальном времени, пожалуйста, подождите...",
  "bmsFirmware.upgradeStatusLabel": "Статус обновления",
  "bmsFirmware.upgradeProgressLabel": "Прогресс обновления",
  "bmsFirmware.currentPackageLabel": "Номер текущего переданного пакета данных",
  "bmsFirmware.totalPackagesLabel": "Общее количество пакетов данных",
  "bmsFirmware.upgradeFailedCheckDevice": "Пожалуйста, проверьте состояние устройства и повторите обновление",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Настройка успешна",
  "settingResult.defaultSubTitle": "Настройки параметров сохранены",
  "settingResult.confirmButton": "OK"
};
